import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import ButtonLink from '../../common/TrackedButtonLink';

class MediaLeftComponentsRight extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }


    render() {
        const { children } = this.props;
        const { title, body, imgSrc, imgAlt } = this.props.data;

        return (
            <div>
                <div className="text-center pt-5 mt-4 px-4">
                    <h2 className="h1 pb-2">{title}</h2>
                    <p>{body}</p>
                </div>
                <div className="product-feature bg-white pb-5">
                    <div className="feature-image mt-4 mx-4 mr-0">
                        <img src={imgSrc} alt={imgAlt} />
                    </div>
                    <div className="feature-content mb-4 px-4" style={{maxWidth: '500px'}}>
                        {children}
                    </div>
                </div>
            </div>
        );
    }
}

export default branch({}, MediaLeftComponentsRight);



// WEBPACK FOOTER //
// ./src/pages/components/page/MediaLeftComponentsRight.js